import { Star } from "lucide-react";

export default function MarkMomentButton({ onMark, disabled }) {
  return (
    <button
      type="button"
      onClick={onMark}
      disabled={disabled}
      data-testid="mark-moment-btn"
      className="sch-cta-gold w-full rounded-xl px-6 py-4 font-display font-bold text-lg flex items-center justify-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <Star className="h-5 w-5 fill-current" />
      MARK MOMENT
      <span className="ml-2 text-xs font-mono font-medium opacity-70">
        captures last ~15s
      </span>
    </button>
  );
}
